// extracted by mini-css-extract-plugin
module.exports = {"searchBoxField":"SearchField_searchBoxField__KoD67","resetBtn":"SearchField_resetBtn__325YF","newLayoutSearch":"SearchField_newLayoutSearch__2ZSIo"};